module.exports = __webpack_public_path__ + "img/bgChart.f3e6f0ee.png";